import { playerIdNameParser } from '../commonInbounds/utils/playerInboundUtils';
import { createArrayWithBracesParser, numberParser } from '../inboundParsers';
export const SIDE_BET_HAND_COMPLETE_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'sideBetJacksPotTotal', parser: numberParser },
        { name: 'jacksWonPerWinner', parser: numberParser },
        { name: 'sideBetWinners', parser: createArrayWithBracesParser(playerIdNameParser) },
        { name: 'sideBetLosers', parser: createArrayWithBracesParser(playerIdNameParser) },
        { name: 'handWinners', parser: createArrayWithBracesParser(playerIdNameParser) }
    ]
};
